<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>User Field</mat-label>
    <mat-select id="user-field" formControlName="userField">
      @for (option of stringUserFieldNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label i18n>Values</mat-label>
    <input matInput type="text" formControlName="userFieldValuesString">
  </mat-form-field>
</ng-container>
